module.exports = __webpack_public_path__ + "img/Oiltanking_South-America_Argentina_Puerto-Rosales_Tanks_2009-03-04_1070341.6bed0e2d.jpg";